import TimelineAccessUserData from "./TimelineAccessUserData";

export enum TimelinePermissions
{
    None = 0,
    Read = 1,
    Share = 2,
    Write = 3,
    Admin = 4
}

export namespace TimelinePermissions
{
    export function check(permission : TimelinePermissions, neededPermission : TimelinePermissions)
    {
        return ((<number>permission) >= (<number>neededPermission));
    }
}

export default class TimelineAccess
{
    static readonly Permissions = TimelinePermissions // allows TimelineAccess.Permissions.*

    // TODO: wrong casing, should refactor later
    User = <TimelineAccessUserData> <unknown> null
    Permission = TimelineAccess.Permissions.None

    static fromJsonObject(data : any)
    {
        const temp = Object.assign(new TimelineAccess, data) as TimelineAccess;
        temp.User = Object.assign(new TimelineAccessUserData, temp.User);
        return temp;
    }
}